import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DataGridView, useSub } from "@neumetric/blueprint-lib/components";
import {
  mitigatorActions,
  getAssetTypesList,
  getAssetsList,
} from "../../../store";

const PER_PAGE = process.env.REACT_APP_INC_PER_PAGE || 9;

const AssetTypeColumns = [
  {
    dataIndex: "asset_type_id",
    typeRepresentation: "LINK",
    title: "Asset Type ID",
    width: "24%",
  },
  {
    dataIndex: "asset_type",
    typeRepresentation: "TEXT",
    title: "Asset Type",
    width: "76%",
    showTooltip: true,
  },
];

const AssetColumns = [
  {
    dataIndex: "asset_id",
    typeRepresentation: "LINK",
    title: "Asset ID",
    width: "20%",
    showTooltip: true,
  },
  {
    dataIndex: "asset_type",
    typeRepresentation: "TEXT",
    title: "Asset Type",
    width: "40%",
    showTooltip: true,
  },
  {
    dataIndex: "asset",
    typeRepresentation: "TEXT",
    title: "Asset",
    width: "40%",
    showTooltip: true,
  },
];

const getTab = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("tab") || "type";
};
const getPage = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("page") || 1;
};

export const MitigatorAssetTrackerScreen = () => {
  const [state, setState] = React.useState({
    activeSubmenu: getTab(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const _ref = React.useRef(null);
  const assetTypesList = useSelector(getAssetTypesList);
  const assetList = useSelector(getAssetsList);
  const _filter = React.useRef({
    defaultPage: getPage(),
    pageNo: getPage(),
    search: "",
    pageSize: PER_PAGE,
  });

  useEffect(() => {
    fetchAssets();
  }, [state.activeSubmenu]);
  useSub("MITIGATOR_SUBMENU_TAB", (data) => {
    setState({
      activeSubmenu: data.tab,
    });
  });

  const dvgOptions = React.useMemo(() => {
    const options = { columns: [], className: "" };
    if (state.activeSubmenu === "type") {
      options.columns = AssetTypeColumns;
      options.className = "w-474-px";
    } else {
      options.columns = AssetColumns;
      options.className = "w-600-px";
    }
    return options;
  }, [state.activeSubmenu]);

  const fetchAssets = () => {
    // console.log({ sctiveSubmenu: state.activeSubmenu });
    if (state.activeSubmenu === "type") {
      dispatch(mitigatorActions.fetchAssetTypeList());
    } else {
      dispatch(mitigatorActions.fetchAssetList());
    }
  };
  const handlePageChange = (pageNo) => {
    navigate(`${window.location.pathname}?page=${pageNo}`);
    _filter.current = { ..._filter.current, pageNo };
    fetchAssets();
  };

  return (
    <div
      className={`col w-100 h-100 overflow-hide ${dvgOptions.className}`}
      ref={_ref}
    >
      <DataGridView
        columns={dvgOptions.columns}
        dataSource={
          state.activeSubmenu === "type"
            ? assetTypesList.map((typ) => ({
                asset_type_id: typ.asset_type_id || "",
                id: typ.id || "",
                asset_type: typ.asset_type || "",
              }))
            : assetList.map((ast) => ({
                asset_id: ast.asset_id || "",
                id: ast.id || "",
                asset_type: ast.asset_type || "",
                asset: ast.asset || "",
              }))
        }
        pagination={{
          pageSize: 9,
          totalCount:
            state.activeSubmenu === "type"
              ? assetTypesList.length
              : assetList.length,
          recentFlag: false,
          defaultPage: _filter.current.defaultPage,
          onPageChange: handlePageChange,
        }}
        getCellSemantics={(column, record) => {
          const params = new URLSearchParams(window.location.search);

          params.set("tab", state.activeSubmenu || "type");
          params.set("open", "view-panel");
          params.set("_ts", Date.now());

          // ✔ CASE 1 → When submenu = "type", click on asset_type_id
          if (
            state.activeSubmenu === "type" &&
            column.dataIndex === "asset_type_id"
          ) {
            return {
              onLinkClick: () => {
                params.set("id", record.id);
                navigate(`${window.location.pathname}?${params.toString()}`);
              },
            };
          }

          // ✔ CASE 2 → When submenu != "asset", click on ID field for assets
          if (
            state.activeSubmenu === "asset" &&
            column.dataIndex === "asset_id"
          ) {
            return {
              onLinkClick: () => {
                params.set("id", record.id);
                navigate(`${window.location.pathname}?${params.toString()}`);
              },
            };
          }

          return {};
        }}
        EmptyComponent={
          <span className="ff-exo2 f16 c777">
            There are no{" "}
            {state.activeSubmenu === "type" ? "Asset Types" : "Assets"} right
            now!
          </span>
        }
      />
    </div>
  );
};
